import { createContext } from "react";

import type { UiOptions } from "./useUiOptions";

interface IDesignProvider {
  options: UiOptions;
  toggleDarkMode: () => void;
  setDarkMode: (enabled: boolean) => void;
  setBorderRadius: (borderRadius: number) => void;
  setFontSize: (fontSize: number) => void;
  reset: () => void;
}

export const DesignProvider = createContext<IDesignProvider>(
  {} as IDesignProvider,
);
